import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, resolveDirective as _resolveDirective, withDirectives as _withDirectives, Transition as _Transition } from "vue"

const _hoisted_1 = {
  class: "layout-navbar d-flex justify-content-between navbar align-items-center bg-white container-p-x",
  id: "layout-navbar"
}
const _hoisted_2 = { class: "d-flex justify-content-between align-items-center" }
const _hoisted_3 = ["src", "alt", "title"]
const _hoisted_4 = ["src", "alt", "title"]
const _hoisted_5 = {
  key: 0,
  class: "d-flex justify-content-between align-items-center"
}
const _hoisted_6 = {
  key: 0,
  class: "d-sm-block d-none"
}
const _hoisted_7 = { class: "nav-item dropdown" }
const _hoisted_8 = { class: "d-inline-flex flex-lg-row-reverse align-items-center align-middle" }
const _hoisted_9 = { class: "d-none d-md-block logged-in-name" }
const _hoisted_10 = {
  key: 0,
  class: "dropdown-menu dropdown-menu-right d-block"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_user_image = _resolveComponent("user-image")!
  const _component_router_link = _resolveComponent("router-link")!
  const _directive_click_outside = _resolveDirective("click-outside")!

  return (_openBlock(), _createElementBlock("nav", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("a", {
        href: "javascript:void(0)",
        onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.sideNavToggle && _ctx.sideNavToggle(...args)))
      }, _cache[7] || (_cache[7] = [
        _createElementVNode("span", { class: "navbar-toggler-icon" }, null, -1)
      ])),
      (_ctx.store.getters.partner && _ctx.store.getters.partner.image && (_ctx.store.getters.partner.image.startsWith('http://') || _ctx.store.getters.partner.image.startsWith('https://')))
        ? (_openBlock(), _createElementBlock("img", {
            key: 0,
            class: "ms-4 cursor-pointer",
            src: _ctx.store.getters.partner.image,
            alt: _ctx.store.getters.partner.short_name +' Logo',
            title: _ctx.store.getters.partner.short_name +' Logo',
            height: "45",
            onClick: _cache[1] || (_cache[1] = ($event: any) => {_ctx.router.push({name:'dashboard'});})
          }, null, 8, _hoisted_3))
        : (_ctx.store.getters.partner && _ctx.store.getters.partner.image)
          ? (_openBlock(), _createElementBlock("img", {
              key: 1,
              class: "ms-4 cursor-pointer",
              src: '/img/partners/'+ _ctx.store.getters.partner.image,
              alt: _ctx.store.getters.partner.short_name +' Logo',
              title: _ctx.store.getters.partner.short_name +' Logo',
              height: "45",
              onClick: _cache[2] || (_cache[2] = ($event: any) => {_ctx.router.push({name:'dashboard'});})
            }, null, 8, _hoisted_4))
          : (_ctx.store.getters.partner && !_ctx.store.getters.partner.image && _ctx.store.getters.partner.is_sim)
            ? (_openBlock(), _createElementBlock("img", {
                key: 2,
                class: "ms-4 cursor-pointer",
                src: "/img/partners/SIMclusive_Logo.png",
                alt: "Simclusive Logo",
                title: "Simclusive Logo",
                height: "45",
                onClick: _cache[3] || (_cache[3] = ($event: any) => {_ctx.router.push({name:'dashboard'});})
              }))
            : (_openBlock(), _createElementBlock("img", {
                key: 3,
                class: "ms-4 cursor-pointer",
                src: "/img/partners/sp-logo.svg",
                alt: "SP-ED Logo",
                title: "SP-ED Logo",
                height: "45",
                onClick: _cache[4] || (_cache[4] = ($event: any) => {_ctx.router.push({name:'dashboard'});})
              }))
    ]),
    (_ctx.store.getters.user)
      ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
          (_ctx.store.getters.partner && _ctx.store.getters.partner.is_sim && _ctx.store.getters.partner.slug != 'simclusive' && _ctx.store.getters.partner.image)
            ? (_openBlock(), _createElementBlock("div", _hoisted_6, _cache[8] || (_cache[8] = [
                _createElementVNode("img", {
                  class: "me-4",
                  src: "/img/partners/SIMclusive_Logo.png",
                  alt: "Simclusive Logo",
                  title: "Simclusive Logo",
                  height: "45"
                }, null, -1)
              ])))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("a", {
              onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.userMenuIsOpen = !_ctx.userMenuIsOpen)),
              class: "nav-link border-none text-primary p-0",
              href: "javascript:void(0)",
              "data-sideNavToggle": "dropdown"
            }, [
              _createElementVNode("span", _hoisted_8, [
                _createVNode(_component_user_image, {
                  size: "ui-w-50",
                  source: _ctx.store.getters.user?.props?.image
                }, null, 8, ["source"]),
                _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.store.getters.user?.props?.first_name + ' '+_ctx.store.getters.user?.props?.last_name), 1)
              ])
            ]),
            _createVNode(_Transition, {
              "enter-active-class": "animate__animated animate__flipInY animate__faster",
              "leave-active-class": "animate__animated animate__flipOutY animate__faster"
            }, {
              default: _withCtx(() => [
                (_ctx.userMenuIsOpen)
                  ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_10, [
                      _createVNode(_component_router_link, {
                        to: "/profile",
                        class: "dropdown-item",
                        role: "menuitem"
                      }, {
                        default: _withCtx(() => _cache[9] || (_cache[9] = [
                          _createElementVNode("i", { class: "fa fa-user text-lightest" }, null, -1),
                          _createTextVNode("   My Profile ")
                        ])),
                        _: 1
                      }),
                      _cache[11] || (_cache[11] = _createElementVNode("div", { class: "dropdown-divider" }, null, -1)),
                      _createElementVNode("a", {
                        href: "javascript:void(0)",
                        onClick: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args))),
                        class: "dropdown-item"
                      }, _cache[10] || (_cache[10] = [
                        _createElementVNode("i", { class: "fa fa-sign-out-alt text-lightest" }, null, -1),
                        _createTextVNode("   Log Out")
                      ]))
                    ])), [
                      [_directive_click_outside, _ctx.profileClose]
                    ])
                  : _createCommentVNode("", true)
              ]),
              _: 1
            })
          ])
        ]))
      : _createCommentVNode("", true)
  ]))
}